exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h2{\r\n  font-size: 2em;\r\n}\r\n\r\np{\r\n  padding-left: 1.5em;\r\n  font-size: 1.3em;\r\n}\r\n\r\na{\r\n  cursor: pointer;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/banaszak60/src/app/main/welcomet/welcomet.component.css
// module id = ../../../../../src/app/main/welcomet/welcomet.component.css
// module chunks = main